import { CHECK_ORDER } from './check_order';
import { Filters } from '../../_flux/constants/filter/filters';
import { getDefaultValueForFilter } from '../../_flux/helper/filters/get_default_value_for_filter';
import { checkFor } from './check_for';
import VehicleConfiguratorStore from '../../_flux/stores/vehicle_configurator_store';

export function checkNextEmptyValueAvailable(changedFilter) {
    const changedIndexInCheckOrder = CHECK_ORDER.indexOf(changedFilter);

    if (changedIndexInCheckOrder === -1) {
        return;
    }

    const vehicleConfiguratorFilterValues = VehicleConfiguratorStore.getState().values;
    let nextToCheck;
    let selectedFilterValues = {};
    let changedFilterDefaultValue;

    // get the next logical input's name
    for (let i = changedIndexInCheckOrder + 1; i < CHECK_ORDER.length; ++i) {
        changedFilterDefaultValue = getDefaultValueForFilter(CHECK_ORDER[i]);

        if (vehicleConfiguratorFilterValues[CHECK_ORDER[i]] === changedFilterDefaultValue) {
            nextToCheck = CHECK_ORDER[i];
            break;
        }
    }
    nextToCheck = CHECK_ORDER[changedIndexInCheckOrder+1];
    // get all the values of input which have been selected already
    for (let i = 0; i < CHECK_ORDER.length; ++i) {
        changedFilterDefaultValue = getDefaultValueForFilter(CHECK_ORDER[i]);
        if (vehicleConfiguratorFilterValues[CHECK_ORDER[i]] !== changedFilterDefaultValue) {
            if (CHECK_ORDER[i] === Filters.VEHICLE_DETAILS) {
                selectedFilterValues[CHECK_ORDER[i]] = vehicleConfiguratorFilterValues.detailsLabel;
                selectedFilterValues.vehicleId = vehicleConfiguratorFilterValues[CHECK_ORDER[i]];
            } else {
                selectedFilterValues[CHECK_ORDER[i]] = vehicleConfiguratorFilterValues[CHECK_ORDER[i]];
            }
        }
    }

    if (nextToCheck) {
        checkFor(selectedFilterValues, nextToCheck, changedFilter);
    }
}
